import React, { useContext } from 'react';
import PriceGrid from './PriceGrid';
import RichText from './richText';
import './layout.css';
import { H1 } from './TahoraUI/Typography';
import Layout from './TahoraUI/Layout';
import { RequestDemoContext } from '../context/RequestDemoContext';

const SliceZone = ({ body, allPriceInfo }) => {
  const { openModal } = useContext(RequestDemoContext);

  return (
    <Layout>
      <div class="bg-white -mt-28 lg:-mt-16">
        <div class="wmax1 mx-auto mb-4 sm:mb-0 bg-white py-16 sm:py-24 sm:px-6 lg:pl-6 lg:pr-0">
          {/*<!-- xs to lg -->*/}

          {/*<!-- lg+ -->*/}
          <div class="hidden lg:block">
            <table class="w-full h-px table-fixed">
              <caption class="sr-only">Pricing plan comparison</caption>
              <thead>
                <tr>
                  <th
                    class="pb-4 w-1/4 px-6 text-sm font-medium text-gray-900 text-left"
                    scope="col"
                  >
                    <span class="sr-only">Feature by</span>
                  </th>

                  <th
                    style={{
                      borderLeftWidth: '3rem',
                      borderRightWidth: '3rem',
                    }}
                    class="w-1/4 caps brief1 py-5 border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
                    scope="col"
                  >
                    <H1
                      style={{
                        fontSize: '40px',
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      <RichText render={allPriceInfo.package_1_title} />
                    </H1>
                  </th>

                  <th
                    style={{
                      borderLeftWidth: '3rem',
                      borderRightWidth: '3rem',
                    }}
                    class="w-1/4 caps brief2 py-5 border-solid border-l-8 border-r-0 border-white mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
                    scope="col"
                  >
                    <H1
                      style={{
                        fontSize: '40px',
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      <RichText render={allPriceInfo.package_2_title} />
                    </H1>
                  </th>

                  <th
                    style={{
                      borderLeftWidth: '3rem',
                      borderRightWidth: '3rem',
                    }}
                    class="w-1/4 brief3 caps py-5 border-solid border-l-8 border-r-0 border-white mx-2 center md:text-base lg:text-lg  leading-6 font-medium text-gray-900 text-left"
                    scope="col"
                  >
                    <H1
                      style={{
                        fontSize: '40px',
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      <RichText render={allPriceInfo.package_3_title} />
                    </H1>
                  </th>
                </tr>
              </thead>

              {body.map((bodyContent, i) => {
                if (bodyContent.type === 'pricing_table_feature') {
                  return (
                    <PriceGrid
                      key={i}
                      features={bodyContent.fields}
                      allPriceInfo={allPriceInfo}
                      // title={bodyContent.primary.pricing_table_feature_title}
                    />
                  );
                } else {
                  return null;
                }
              })}

              <tfoot>
                <tr class="border-t border-gray-200 ">
                  <th class="sr-only" scope="row">
                    Choose your plan
                  </th>

                  <td
                    style={{
                      borderLeftWidth: '3rem',
                      borderRightWidth: '3rem',
                    }}
                    class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
                  >
                    <div
                      onClick={openModal}
                      class="cursor-pointer inline-flex rounded-full w-5/6 flex justify-center border-solid border-2 borderbttn btnText buttonhov1 hover:bg-gray-50"
                    >
                      <div class="inline-flex items-center justify-center px-5 py-3 border bluenorm border-transparent text-base font-medium rounded-full ">
                        <div className=" btnText"> Get Started</div>
                      </div>
                    </div>
                  </td>

                  <td
                    style={{
                      borderLeftWidth: '3rem',
                      borderRightWidth: '3rem',
                    }}
                    class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
                  >
                    <div
                      onClick={openModal}
                      class="cursor-pointer inline-flex rounded-full w-5/6 flex justify-center border-solid border-2 borderbttn btnText buttonhov1 hover:bg-gray-50"
                    >
                      <div class="inline-flex items-center justify-center px-5 py-3 border bluenorm border-transparent text-base font-medium rounded-full ">
                        <div className=" btnText"> Get Started</div>
                      </div>
                    </div>
                  </td>

                  <td
                    style={{
                      borderLeftWidth: '3rem',
                      borderRightWidth: '3rem',
                    }}
                    class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
                  >
                    <div
                      onClick={openModal}
                      class="cursor-pointer inline-flex rounded-full w-5/6 flex justify-center border-solid border-2 borderbttn btnText buttonhov1 hover:bg-gray-50"
                    >
                      <div class="inline-flex items-center justify-center px-5 py-3 border bluenorm border-transparent text-base font-medium rounded-full ">
                        <div className=" btnText">Get In Touch</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SliceZone;
